module.exports = __webpack_public_path__ + "static/media/spotifyguide.adbaa4f2.gif";